import _styled from "styled-components";
import React from 'react';
import { useSearchSuggestionsHeight } from "./useSearchSuggestionsContainerHeight";
import * as styles from "./SearchSuggestionsContainer.styles";
import { useSearchContext } from "../../../context/SearchContext/useSearchContext";
export var SearchSuggestionsContainer = function SearchSuggestionsContainer() {
  var _useSearchContext = useSearchContext(),
    _useSearchContext$sea = _useSearchContext.search,
    isSuggestionsShown = _useSearchContext$sea.isSuggestionsShown,
    suggestions = _useSearchContext$sea.suggestions,
    current = _useSearchContext.searchSuggestionsRef.current;
  var height = useSearchSuggestionsHeight(current, suggestions);
  return isSuggestionsShown ? /*#__PURE__*/React.createElement(_StyledDiv, {
    "data-testid": "search-suggestions-container",
    style: {
      '--suggestionsHeight': "".concat(height, "px")
    },
    $_css: styles.searchSuggestionsContainer
  }) : null;
};
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "SearchSuggestionsContainer___StyledDiv",
  componentId: "sc-vnuh0s-0"
})(["", ""], function (p) {
  return p.$_css;
});